"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getCancelInfo;

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/* istanbul ignore file */


function getCancelInfo() {
  var CancelToken = _axios["default"].CancelToken;
  var source = CancelToken.source();
  var cancelToken = source.token;
  return {
    cancelToken: cancelToken,
    source: source
  };
}